import styled from '@emotion/styled'

import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import minus from '@vio/atlas/utils/minus'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`
export const ReviewSummaryWrapper = styled(Wrapper)`
  margin-right: ${minus(cssTheme.layout.spacing.s400)};
  margin-left: ${minus(cssTheme.layout.spacing.s500)};
`

export const ReviewRatingWrapper = styled.div`
  align-items: flex-start;
  margin-right: ${cssTheme.layout.spacing.s500};
  flex-shrink: 0;
  ${linariaMq.desktopXs} {
    margin-right: ${cssTheme.layout.spacing.s600} !important;
  }
`

export const ReviewRatingButton = styled(NoStyleButton)`
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
`

export const APFoldReviewRatingButton = styled(ReviewRatingButton)`
  padding-top: ${cssTheme.layout.spacing.s400};
  padding-bottom: ${cssTheme.layout.spacing.s300};
`

export const SentimentTagsWrapper = styled.div`
  padding-top: ${cssTheme.layout.spacing.s300};
  padding-bottom: ${cssTheme.layout.spacing.s500};
  padding-left: ${cssTheme.layout.spacing.s500};
`
